import React, { useRef } from "react";
import { Field, ErrorMessage, useFormikContext } from "formik";
import "../CustomInputLogin/CustomInputLogin.css";
import { Grid, TextField } from "@mui/material";
import { Height } from "@mui/icons-material";
import { BiBorderRadius } from "react-icons/bi";

const CustomFromAndToDate = ({ label1, label2 }) => {
  const { values, setFieldValue } = useFormikContext();

  // Determine dynamic min and max dates based on selections
  const fromDateMax = values.toDate || undefined;
  const toDateMin = values.fromDate || undefined;

  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);

  const handleFromClick = () => {
    if (fromDateRef.current) {
      fromDateRef.current.showPicker?.(); // Modern browsers
      fromDateRef.current.focus();        // Fallback
    }
  };

  const handleToClick = () => {
    if (toDateRef.current) {
      toDateRef.current.showPicker?.();
      toDateRef.current.focus();
    }
  };


  // Handle changes for `fromDate`
  const handleFromDateChange = (e) => {
    const selectedDate = e.target.value;
    setFieldValue("fromDate", selectedDate);

    // Clear `toDate` if it’s before the newly selected `fromDate`
    if (values.toDate && new Date(values.toDate) < new Date(selectedDate)) {
      setFieldValue("toDate", "");
    }
  };

  // Handle changes for `toDate`
  const handleToDateChange = (e) => {
    const selectedDate = e.target.value;
    setFieldValue("toDate", selectedDate);

    // Clear `fromDate` if it’s after the newly selected `toDate`
    if (values.fromDate && new Date(selectedDate) < new Date(values.fromDate)) {
      setFieldValue("fromDate", "");
    }
  };

  return (
    // <div style={{ width: "100%" }}>
    //   <div style={{ display: "flex", gap: "15px" }}>
    //     <div style={{ flex: 1 }}>
    //       <label
    //         htmlFor="fromDate"
    //         className="input-heading12"
    //         style={{ fontSize: "16px", fontWeight: "700", display: "block" }}
    //       >
    //         From Date
    //       </label>
    //       <Field
    //         id="fromDate"
    //         name="fromDate"
    //         type="date"
    //         max={fromDateMax} // Limit up to selected `toDate`
    //         onChange={handleFromDateChange}
    //         style={{ width: "100%", padding: "8px", fontSize: "16px" }}
    //         className="custominput-field12"
    //       />
    //       <ErrorMessage
    //         name="fromDate"
    //         component="div"
    //         className="inputs-error-msg"
    //         style={{ color: "red" }}
    //       />
    //     </div>

    //     <div style={{ flex: 1 }}>
    //       <label
    //         htmlFor="toDate"
    //         className="input-heading12"
    //         style={{ fontSize: "16px", fontWeight: "700", display: "block" }}
    //       >
    //         To Date
    //       </label>
    //       <Field
    //         id="toDate"
    //         name="toDate"
    //         type="date"
    //         min={toDateMin} // Start from selected `fromDate`
    //         onChange={handleToDateChange}
    //         style={{ width: "100%", padding: "8px", fontSize: "16px" }}
    //         className="custominput-field12"
    //       />
    //       <ErrorMessage
    //         name="toDate"
    //         component="div"
    //         className="inputs-error-msg"
    //         style={{ color: "red" }}
    //       />
    //     </div>
    //   </div>
    // </div>
    // <Grid container spacing={2}>
    <>
      <Grid item size={{ md: 4, xs: 12, sm: 6 }}>
        <label
          htmlFor="fromDate"
          className="input-heading12"
          style={{ fontSize: "15px", fontWeight: "450", display: "block", marginBottom: "6px" }}
        >
          {/* From Date */}
          {label1}
        </label>
        <Field
          onClick={handleFromClick}
          ref={fromDateRef}

          id="fromDate"
          name="fromDate"
          type="date"
          max={fromDateMax} // Limit up to selected `toDate`
          onChange={handleFromDateChange}
          style={{ width: "96%", padding: "3px 3px 3px 10px", fontSize: "16px", Height: "25px" }}
          className="custominputData-field12"
        />
        <ErrorMessage
          name="fromDate"
          component="div"
          className="inputs-error-msg"
          style={{ color: "red", fontSize: "12px" }}
        />
      </Grid>

      <Grid item size={{ md: 4, xs: 12, sm: 6 }}>
        <label
          htmlFor="toDate"
          className="input-heading12"
          style={{ fontSize: "15px", fontWeight: "450", display: "block", marginBottom: "5px" }}
        >
          {/* To Date */}
          {label2}
        </label>
        <Field
          onClick={handleToClick}
          ref={toDateRef}
          id="toDate"
          name="toDate"
          type="date"
          min={toDateMin} // Start from selected `fromDate`
          onChange={handleToDateChange}
          style={{ width: "96%", padding: "3px 3px 3px 10px", fontSize: "16px", Height: "20px", BiBorderRadius: "2px" }}
          className="custominputData-field12"
        />
        <ErrorMessage
          name="toDate"
          component="div"
          className="inputs-error-msg"
          style={{ color: "red", fontSize: "12px" }}
        />
      </Grid>
      {/* </Grid> */}
    </>
  );
};

export default CustomFromAndToDate;


// import React from "react";
// import { Field, ErrorMessage, useFormikContext } from "formik";
// import "../CustomInputLogin/CustomInputLogin.css";
// import { Grid, TextField } from "@mui/material";
// import { Height } from "@mui/icons-material";
// import { BiBorderRadius } from "react-icons/bi";

// const CustomFromAndToDate = ({ label1, label2 }) => {
//   const { values, setFieldValue } = useFormikContext();

//   // Determine dynamic min and max dates based on selections
//   const fromDateMax = values.toDate || undefined;
//   const toDateMin = values.fromDate || undefined;

//   // Handle changes for `fromDate`
//   const handleFromDateChange = (e) => {
//     const selectedDate = e.target.value;
//     setFieldValue("fromDate", selectedDate);

//     // Clear `toDate` if it’s before the newly selected `fromDate`
//     if (values.toDate && new Date(values.toDate) < new Date(selectedDate)) {
//       setFieldValue("toDate", "");
//     }
//   };

//   // Handle changes for `toDate`
//   const handleToDateChange = (e) => {
//     const selectedDate = e.target.value;
//     setFieldValue("toDate", selectedDate);

//     // Clear `fromDate` if it’s after the newly selected `toDate`
//     if (values.fromDate && new Date(selectedDate) < new Date(values.fromDate)) {
//       setFieldValue("fromDate", "");
//     }
//   };

//   return (
//     // <div style={{ width: "100%" }}>
//     //   <div style={{ display: "flex", gap: "15px" }}>
//     //     <div style={{ flex: 1 }}>
//     //       <label
//     //         htmlFor="fromDate"
//     //         className="input-heading12"
//     //         style={{ fontSize: "16px", fontWeight: "700", display: "block" }}
//     //       >
//     //         From Date
//     //       </label>
//     //       <Field
//     //         id="fromDate"
//     //         name="fromDate"
//     //         type="date"
//     //         max={fromDateMax} // Limit up to selected `toDate`
//     //         onChange={handleFromDateChange}
//     //         style={{ width: "100%", padding: "8px", fontSize: "16px" }}
//     //         className="custominput-field12"
//     //       />
//     //       <ErrorMessage
//     //         name="fromDate"
//     //         component="div"
//     //         className="inputs-error-msg"
//     //         style={{ color: "red" }}
//     //       />
//     //     </div>

//     //     <div style={{ flex: 1 }}>
//     //       <label
//     //         htmlFor="toDate"
//     //         className="input-heading12"
//     //         style={{ fontSize: "16px", fontWeight: "700", display: "block" }}
//     //       >
//     //         To Date
//     //       </label>
//     //       <Field
//     //         id="toDate"
//     //         name="toDate"
//     //         type="date"
//     //         min={toDateMin} // Start from selected `fromDate`
//     //         onChange={handleToDateChange}
//     //         style={{ width: "100%", padding: "8px", fontSize: "16px" }}
//     //         className="custominput-field12"
//     //       />
//     //       <ErrorMessage
//     //         name="toDate"
//     //         component="div"
//     //         className="inputs-error-msg"
//     //         style={{ color: "red" }}
//     //       />
//     //     </div>
//     //   </div>
//     // </div>
//     // <Grid container spacing={2}>
//     <>
//       <Grid
//       // item size={{ md: 4, xs: 12, sm: 6 }}
//       >

//         <label
//           htmlFor="fromDate"
//           className="input-heading12"
//           style={{ fontSize: "15px", fontWeight: "450", display: "block", marginBottom: "6px" }}
//         >
//           {/* From Date */}
//           {label1}
//         </label>
//         <Field
//           id="fromDate"
//           name="fromDate"
//           type="date"
//           max={fromDateMax} // Limit up to selected `toDate`
//           onChange={handleFromDateChange}
//           style={{ width: "96%", padding: "3px 3px 3px 10px", fontSize: "16px", Height: "25px" }}
//           className="custominputData-field12"
//         />
//         <ErrorMessage
//           name="fromDate"
//           component="div"
//           className="inputs-error-msg"
//           style={{ color: "red", fontSize: "12px" }}
//         />
//       </Grid>

//       <Grid
//       // item size={{ md: 4, xs: 12, sm: 6 }}
//       >
//         <label
//           htmlFor="toDate"
//           className="input-heading12"
//           style={{ fontSize: "15px", fontWeight: "450", display: "block", marginBottom: "5px" }}
//         >
//           {/* To Date */}
//           {label2}
//         </label>
//         <Field
//           id="toDate"
//           name="toDate"
//           type="date"
//           min={toDateMin} // Start from selected `fromDate`
//           onChange={handleToDateChange}
//           style={{ width: "96%", padding: "3px 3px 3px 10px", fontSize: "16px", Height: "20px", BiBorderRadius: "2px" }}
//           className="custominputData-field12"
//         />
//         <ErrorMessage
//           name="toDate"
//           component="div"
//           className="inputs-error-msg"
//           style={{ color: "red", fontSize: "12px" }}
//         />
//       </Grid>
//       {/* </Grid> */}
//     </>
//   );
// };

// export default CustomFromAndToDate;
